import { useState, useEffect } from "react";
import { FaBars, FaTimes, FaUser, FaSignOutAlt, FaChevronDown, FaCalculator, FaTrophy, FaFire, FaCrown, FaStar, FaKey, FaRobot, FaComments, FaCode, FaHome, FaQuestionCircle, FaBookOpen, FaChalkboardTeacher, FaChartBar, FaClipboardCheck, FaQuestion, FaEnvelope, FaInfoCircle, FaCompass, FaGamepad, FaFlask, FaChartLine, FaClock, FaUsers, FaBook, FaFolder, FaClipboardList, FaHistory, FaCalendarAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout, checkAuthStatus, fetchUserProfile } from "../../redux/slices/authSlice";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Navbar.css";
import DarkModeToggle from "../DarkModeToggle/DarkModeToggle";
import { Link } from "react-router-dom";

function Navbar() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isAuthenticated, currentUser, profileData } = useSelector((state) => state.auth);

    const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [showUserMenu, setShowUserMenu] = useState(false);
    const [showMobileUserMenu, setShowMobileUserMenu] = useState(false);
    const [showDesktopMenu, setShowDesktopMenu] = useState(false);

    // Check auth status on component mount
    useEffect(() => {
        dispatch(checkAuthStatus());
    }, [dispatch]);

    // Fetch profile data when authenticated
    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchUserProfile());
        }
    }, [dispatch, isAuthenticated]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            if (scrollTop > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleLogout = () => {
        dispatch(logout());
        setShowUserMenu(false);
        toast.success("تم تسجيل الخروج بنجاح");
        setTimeout(() => {
            window.location.reload();
        }, 1000);
    };

    const handleUserMenuClick = () => {
        setShowUserMenu(!showUserMenu);
    };

    const handleMobileUserMenuClick = () => {
        setShowMobileUserMenu(!showMobileUserMenu);
    };


    return (
        <>
            <nav className={`navbar navbar-expand-lg bg-white py-0 shadow-sm fixed-top border-bottom custom-navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
                <div className="container-fluid px-0 d-flex justify-content-between align-items-center">
                    {/* Left side - Logo, Dark Mode Toggle, and Menu Toggle */}
                    <div className="d-flex align-items-center">
                        {/* Logo */}
                        <a className="navbar-brand px-4" href="/">
                            <img src="/3almnyLogo.png" alt="Logo" className="navbar-logo" />
                        </a>

                        {/* Dark Mode Toggle - Next to logo */}
                        <div className="dark-mode-toggle-wrapper ms-3">
                            <DarkModeToggle />
                        </div>

                        {/* Desktop Menu Toggle Button - Next to Dark Mode Toggle */}
                        <div className="desktop-menu-wrapper position-relative">
                            <button 
                                className="btn btn-primary d-none d-xl-flex align-items-center gap-2 desktop-menu-toggle ms-3"
                                onClick={() => setShowDesktopMenu(!showDesktopMenu)}
                                style={{
                                    padding: '8px 16px',
                                    borderRadius: '8px',
                                    border: 'none',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    zIndex: 10
                                }}
                            >
                                <FaBars />
                                {showDesktopMenu ? 'إغلاق القائمة' : 'قائمة علمني'}
                            </button>

                            {/* Desktop Menu Dropdown - تحت الزر مباشرة */}
                            {showDesktopMenu && (
                                <>
                                    <div
                                        className="desktop-menu-backdrop"
                                        onClick={() => setShowDesktopMenu(false)}
                                    ></div>
                                    <div className="desktop-menu-dropdown">
                                        <ul className="desktop-menu-list">
                                            {/* 1. الرئيسية والمكتبة أولاً */}
                                            <li>
                                                <Link to="/" onClick={() => setShowDesktopMenu(false)}>
                                                    <FaHome className="mx-2" />
                                                    الرئيسية
                                                </Link>
                                            </li>
                                            
                                            <li>
                                                <Link to="/Library" onClick={() => setShowDesktopMenu(false)}>
                                                    <FaBookOpen className="mx-1" style={{color: '#17a2b8'}} />
                                                    مكتبة علمني
                                                </Link>
                                            </li>
                                            
                                            {/* 2. الروابط الخاصة بالطالب/ولي الأمر/المعلم */}
                                            {currentUser?.role === "parent" ? (
                                                <>
                                                    <li><Link to="/parent-child-lessons" onClick={() => setShowDesktopMenu(false)}><FaBookOpen className="mx-1" style={{color: '#17a2b8'}} />دروس الأبناء</Link></li>
                                                    <li><Link to="/teachers" onClick={() => setShowDesktopMenu(false)}><FaChalkboardTeacher className="mx-1" style={{color: '#6f42c1'}} />المعلمين</Link></li>
                                                    <li><Link to="/parent-child-reports" onClick={() => setShowDesktopMenu(false)}><FaChartBar className="mx-1" style={{color: '#fd7e14'}} />تقارير الأبناء</Link></li>
                                                    <li><Link to="/parent-child-tests" onClick={() => setShowDesktopMenu(false)}><FaClipboardCheck className="mx-1" style={{color: '#20c997'}} />اختبارات الأبناء</Link></li>
                                                    <li><Link to="/questions" onClick={() => setShowDesktopMenu(false)}><FaQuestion className="mx-1" style={{color: '#e83e8c'}} />سؤال وجواب</Link></li>
                                                    <li><Link to="/level-indicator" onClick={() => setShowDesktopMenu(false)}><FaChartLine className="mx-1" style={{color: '#00d4aa'}} />مؤشر المستوى</Link></li>
                                                </>
                                            ) : currentUser?.role === "teacher" ? (
                                                <>
                                                    <li><Link to="/lessons" onClick={() => setShowDesktopMenu(false)}><FaClock className="mx-2" style={{color: '#17a2b8'}} />الحصص</Link></li>
                                                    <li><Link to="/students" onClick={() => setShowDesktopMenu(false)}><FaUsers className="mx-2" style={{color: '#6f42c1'}} />الطلاب</Link></li>
                                                    <li><Link to="/subjects" onClick={() => setShowDesktopMenu(false)}><FaBook className="mx-1" style={{color: '#17a2b8'}} />المواد</Link></li>
                                                    <li><Link to="/files" onClick={() => setShowDesktopMenu(false)}><FaFolder className="mx-1" style={{color: '#fd7e14'}} />ملفاتي</Link></li>
                                                    <li><Link to="/questions" onClick={() => setShowDesktopMenu(false)}><FaQuestion className="mx-2" style={{color: '#e83e8c'}} />سؤال وجواب</Link></li>
                                                    <li><Link to="/exams" onClick={() => setShowDesktopMenu(false)}><FaClipboardList className="mx-1" style={{color: '#20c997'}} />الاختبارات</Link></li>
                                                    <li><Link to="/exam-history" onClick={() => setShowDesktopMenu(false)}><FaHistory className="mx-1" style={{color: '#6c757d'}} />سجل الاختبارات</Link></li>
                                                </>
                                            ) : (
                                                <>
                                                    <li><Link to="/lessons" onClick={() => setShowDesktopMenu(false)}><FaClock className="mx-1" style={{color: '#17a2b8'}} />الحصص</Link></li>
                                                    <li><Link to="/teachers" onClick={() => setShowDesktopMenu(false)}><FaChalkboardTeacher className="mx-1" style={{color: '#6f42c1'}} />المدرسين</Link></li>
                                                    <li><Link to="/subjects" onClick={() => setShowDesktopMenu(false)}><FaBook className="mx-1" style={{color: '#17a2b8'}} />المواد</Link></li>
                                                    <li><Link to="/files" onClick={() => setShowDesktopMenu(false)}><FaFolder className="mx-1" style={{color: '#fd7e14'}} />ملفاتي</Link></li>
                                                    <li><Link to="/questions" onClick={() => setShowDesktopMenu(false)}><FaQuestion className="mx-2" style={{color: '#e83e8c'}} />سؤال وجواب</Link></li>
                                                    <li><Link to="/level-indicator" onClick={() => setShowDesktopMenu(false)}><FaTrophy className="mx-1" style={{color: '#ffc107'}} />مؤشر المستوى</Link></li>
                                                    <li><Link to="/exams" onClick={() => setShowDesktopMenu(false)}><FaClipboardList className="mx-1" style={{color: '#20c997'}} />الاختبارات</Link></li>
                                                    <li><Link to="/schedule" onClick={() => setShowDesktopMenu(false)}><FaCalendarAlt className="mx-1" style={{color: '#667eea'}} />جدول المواعيد</Link></li>
                                                    <li><Link to="/exam-history" onClick={() => setShowDesktopMenu(false)}><FaHistory className="mx-1" style={{color: '#6c757d'}} />سجل الاختبارات</Link></li>
                                                    <li><Link to="/check-code" onClick={() => setShowDesktopMenu(false)}><FaKey className="mx-1" style={{color: '#6c757d'}} />تفعيل كود المادة</Link></li>
                                                </>
                                            )}
                                            
                                            {/* 3. الروابط العامة في النهاية */}
                                            <li><Link to="/competitions" onClick={() => setShowDesktopMenu(false)}><FaCrown className="mx-1" style={{color: '#ffc107'}} />مسابقات وجوائز علمني</Link></li>
                                            <li><Link to="/play" onClick={() => setShowDesktopMenu(false)}><FaGamepad className="mx-1" style={{color: '#ff6b35'}} />امرح مع علمني</Link></li>
                                            <li><Link to="/discover" onClick={() => setShowDesktopMenu(false)}><FaCompass className="mx-1" style={{color: '#28a745'}} />استكشف</Link></li>
                                            <li><Link to="/about" onClick={() => setShowDesktopMenu(false)}><FaInfoCircle className="mx-1" style={{color: '#6c757d'}} />من نحن</Link></li>
                                            <li><Link to="/contact" onClick={() => setShowDesktopMenu(false)}><FaEnvelope className="mx-1" style={{color: '#dc3545'}} />تواصل معنا</Link></li>
                                        </ul>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    {/* Center - Navigation Links - Always visible */}
                    <ul 
                        className="navbar-nav d-none d-xl-flex flex-row gap-4 mb-0 align-items-center mx-auto"
                    >
                        {/* 1. الرئيسية والمكتبة أولاً */}
                        <li className="nav-item">
                            <a className="nav-link fw-bold text-primary" href="/">
                                <FaHome className="mx-2" />
                                الرئيسية
                            </a>
                        </li>
                        
                        <li className="nav-item">
                            <a className="nav-link" href="/Library">
                                <FaBookOpen className="mx-1" style={{color: '#17a2b8'}} />
                                مكتبة علمني
                            </a>
                        </li>
                        
                        {/* 2. الروابط الخاصة بالطالب/ولي الأمر/المعلم */}
                        {currentUser?.role === "parent" ? (
                            // روابط ولي الأمر
                            <>
                                <li className="nav-item">
                                    <a className="nav-link" href="/parent-child-lessons">
                                        <FaBookOpen className="mx-1" style={{color: '#17a2b8'}} />
                                        دروس الأبناء
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/teachers">
                                        <FaChalkboardTeacher className="mx-1" style={{color: '#6f42c1'}} />
                                        المعلمين
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/parent-child-reports">
                                        <FaChartBar className="mx-1" style={{color: '#fd7e14'}} />
                                        تقارير الأبناء
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/parent-child-tests">
                                        <FaClipboardCheck className="mx-1" style={{color: '#20c997'}} />
                                        اختبارات الأبناء
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/questions">
                                        <FaQuestion className="mx-1" style={{color: '#e83e8c'}} />
                                        سؤال وجواب
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/level-indicator">
                                        <FaChartLine className="mx-1" style={{color: '#00d4aa'}} />
                                        مؤشر المستوى
                                    </a>
                                </li>
                            </>
                        ) : currentUser?.role === "teacher" ? (
                            // روابط المعلم
                            <>
                                <li className="nav-item">
                                    <a className="nav-link" href="/lessons">
                                        <FaClock className="mx-2" style={{color: '#17a2b8'}} />
                                        الحصص
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/students">
                                        <FaUsers className="mx-2" style={{color: '#6f42c1'}} />
                                        الطلاب
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/subjects">
                                        <FaBook className="mx-1" style={{color: '#17a2b8'}} />
                                        المواد
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/files">
                                        <FaFolder className="mx-1" style={{color: '#fd7e14'}} />
                                        ملفاتي
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/questions">
                                        <FaQuestion className="mx-2" style={{color: '#e83e8c'}} />
                                        سؤال وجواب
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/exams">
                                        <FaClipboardList className="mx-1" style={{color: '#20c997'}} />
                                        الاختبارات
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/exam-history">
                                        <FaHistory className="mx-1" style={{color: '#6c757d'}} />
                                        سجل الاختبارات
                                    </a>
                                </li>
                            </>
                        ) : (
                            // روابط الطالب (الافتراضية)
                            <>
                                <li className="nav-item">
                                    <a className="nav-link" href="/lessons">
                                        <FaClock className="mx-1" style={{color: '#17a2b8'}} />
                                        الحصص
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/teachers">
                                        <FaChalkboardTeacher className="mx-1" style={{color: '#6f42c1'}} />
                                        المدرسين
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/subjects">
                                        <FaBook className="mx-1" style={{color: '#17a2b8'}} />
                                        المواد
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/files">
                                        <FaFolder className="mx-1" style={{color: '#fd7e14'}} />
                                        ملفاتي
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/questions">
                                        <FaQuestion className="mx-2" style={{color: '#e83e8c'}} />
                                        سؤال وجواب
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/level-indicator">
                                        <FaTrophy className="mx-1" style={{color: '#ffc107'}} />
                                        مؤشر المستوى
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/exams">
                                        <FaClipboardList className="mx-1" style={{color: '#20c997'}} />
                                        الاختبارات
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/schedule">
                                        <FaCalendarAlt className="mx-1" style={{color: '#667eea'}} />
                                        جدول المواعيد
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/exam-history">
                                        <FaHistory className="mx-1" style={{color: '#6c757d'}} />
                                        سجل الاختبارات
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/check-code">
                                        <FaKey className="mx-1" style={{color: '#6c757d'}} />
                                        تفعيل كود المادة
                                    </a>
                                </li>
                            </>
                        )}
                        
                        {/* 3. الروابط العامة في النهاية */}
                        <li className="nav-item">
                            <a className="nav-link" href="/competitions">
                                <FaCrown className="mx-1" style={{color: '#ffc107'}} />
                                مسابقات وجوائز علمني
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/play">
                                <FaGamepad className="mx-1" style={{color: '#ff6b35'}} />
                                امرح مع علمني
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/discover">
                                <FaCompass className="mx-1" style={{color: '#28a745'}} />
                                استكشف
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/about">
                                <FaInfoCircle className="mx-1" style={{color: '#6c757d'}} />
                                من نحن
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/contact">
                                <FaEnvelope className="mx-1" style={{color: '#dc3545'}} />
                                تواصل معنا
                            </a>
                        </li>
                    </ul>


                    {/* Right side - Login Button or User Menu */}
                    <div className="d-none d-xl-flex align-items-center login-box position-relative me-4">
                        {isAuthenticated ? (
                            <>
                                <div className="slanted-bg" style={{zIndex : "1"}}></div>

                                <Link onClick={handleUserMenuClick} className="btn btn-light text-primary fw-bold z-1 px-4 py-2 rounded-pill position-relative d-flex align-items-center gap-2">
                                    <img 
                                        src={profileData?.prof_img || "/user.png"} 
                                        alt="Profile" 
                                        className="user-profile-image-small"
                                        onError={(e) => {
                                            e.target.src = "/user.png";
                                        }}
                                    />
                                    <FaChevronDown className={`dropdown-arrow ${showUserMenu ? 'rotated' : ''}`} />
                                </Link>
                                {showUserMenu && (

                                    <div className="user-dropdown-menu">
                                        <div className="user-info">
                                            <div className="user-profile-display">
                                                <img 
                                                    src={profileData?.prof_img || "/user.png"} 
                                                    alt="Profile" 
                                                    className="user-profile-image"
                                                    onError={(e) => {
                                                        e.target.src = "/user.png";
                                                    }}
                                                />
                                                <div className="user-details">
                                                    <div className="user-name">{profileData?.name || currentUser?.name || 'المستخدم'}</div>
                                            <div className="user-role">{currentUser?.role === 'student' ? 'طالب' : currentUser?.role === 'teacher' ? 'معلم' : 'ولي أمر'}</div>
                                                </div>
                                            </div>
                                            {currentUser?.role === 'student' && profileData?.stud_code && (
                                                <div className="user-id">
                                                    كود الطالب: {profileData.stud_code}
                                                </div>
                                            )}
                                        </div>
                                        <div className="dropdown-divider"></div>
                                        <Link to="/profile" className="dropdown-item d-flex align-items-center gap-2" onClick={() => setShowUserMenu(false)}>
                                            <FaUser />
                                            الملف الشخصي
                                        </Link>
                                        <Link to="/check-code" className="dropdown-item d-flex align-items-center gap-2" onClick={() => setShowUserMenu(false)}>
                                            <FaKey />
                                            تفعيل كود المادة
                                        </Link>
                                        <button
                                            className="dropdown-item d-flex align-items-center gap-2"
                                            onClick={handleLogout}
                                        >
                                            <FaSignOutAlt />
                                            تسجيل الخروج
                                        </button>
                                    </div>
                                )}
                            </>




                        ) : (
                            <>
                                <div className="slanted-bg"></div>
                                <Link to="/login" className="btn btn-light text-primary fw-bold z-1 px-4 py-2 rounded-pill position-relative">
                                    تسجيل الدخول
                                </Link>
                            </>
                        )}
                    </div>

                    {/* Mobile Toggle */}
                    <button className="btn d-xl-none mobile-toggle-btn" onClick={() => setIsOpen(true)}>
                        <FaBars size={24} />
                    </button>
                </div>
            </nav>

            {/* Backdrop Overlay */}
            {isOpen && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
                    style={{ zIndex: 9998 }}
                    onClick={() => setIsOpen(false)}
                ></div>
            )}

            {/* Mobile Sidebar */}
            <div className={`mobile-sidebar ${isOpen ? 'open' : ''}`}>
                <div className="mobile-sidebar-header">
                    <img src="/3almnyLogo.png" alt="Logo" className="mobile-logo" />
                    <button className="close-btn" onClick={() => setIsOpen(false)}>
                        <FaTimes size={24} />
                    </button>
                </div>

                <div className="mobile-sidebar-content">
                    {/* قسم تسجيل الدخول/معلومات المستخدم - في الأعلى */}
                    <div className="mobile-auth-section">
                        {isAuthenticated ? (
                            <div className="mobile-user-dropdown">
                                <button 
                                    className="btn btn-primary w-100 d-flex align-items-center justify-content-between"
                                    onClick={handleMobileUserMenuClick}
                                >
                                    <div className="d-flex align-items-center">
                                    <img 
                                        src={profileData?.prof_img || "/user.png"} 
                                        alt="Profile" 
                                        className="user-profile-image-small"
                                        onError={(e) => {
                                            e.target.src = "/user.png";
                                        }}
                                    />
                                        <span className="user-name-display ms-3">
                                            {profileData?.name || currentUser?.name || 'المستخدم'}
                                        </span>
                                    </div>
                                    <FaChevronDown className={`dropdown-arrow ${showMobileUserMenu ? 'rotated' : ''}`} />
                                </button>
                                
                                {showMobileUserMenu && (
                                    <div className="mobile-dropdown-menu">
                                        <div className="mobile-user-info">
                                            <div className="user-profile-display">
                                                <img 
                                                    src={profileData?.prof_img || "/user.png"} 
                                                    alt="Profile" 
                                                    className="user-profile-image"
                                                    onError={(e) => {
                                                        e.target.src = "/user.png";
                                                    }}
                                                />
                                                <div className="user-details">
                                                    <div className="user-name">{profileData?.name || currentUser?.name || 'المستخدم'}</div>
                                            <div className="user-role">{currentUser?.role === 'student' ? 'طالب' : currentUser?.role === 'teacher' ? 'معلم' : 'ولي أمر'}</div>
                                                </div>
                                            </div>
                                            {currentUser?.role === 'student' && profileData?.stud_code && (
                                                <div className="user-id">
                                                    كود الطالب: {profileData.stud_code}
                                                </div>
                                            )}
                                        </div>
                                        <div className="dropdown-divider"></div>
                                        <Link 
                                            to="/profile" 
                                            className="mobile-dropdown-item"
                                            onClick={() => {
                                                setIsOpen(false);
                                                setShowMobileUserMenu(false);
                                            }}
                                        >
                                            <FaUser className="mx-2" />
                                            الملف الشخصي
                                        </Link>
                                        <Link 
                                            to="/check-code" 
                                            className="mobile-dropdown-item"
                                            onClick={() => {
                                                setIsOpen(false);
                                                setShowMobileUserMenu(false);
                                            }}
                                        >
                                            <FaKey className="mx-2" />
                                            تفعيل كود المادة
                                        </Link>
                                        <button
                                            className="mobile-dropdown-item btn-danger"
                                            onClick={() => {
                                                handleLogout();
                                                setIsOpen(false);
                                                setShowMobileUserMenu(false);
                                            }}
                                        >
                                            <FaSignOutAlt className="mx-2" />
                                            تسجيل الخروج
                                        </button>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <Link to="/login" className="btn btn-primary w-100" onClick={() => setIsOpen(false)}>
                                تسجيل الدخول
                            </Link>
                        )}
                    </div>

                    <ul className="mobile-nav-list">
                        <li><a href="/" onClick={() => setIsOpen(false)}><FaHome className="mx-2" style={{color: '#28a745'}} />الرئيسية</a></li>
                        
                        {/* مكتبة علمني في الموبايل - متاحة للجميع */}
                        <li><a href="/Library" onClick={() => setIsOpen(false)}><FaBookOpen className="mx-2" style={{color: '#17a2b8'}} />مكتبة علمني</a></li>
                        
                        {/* رابط مساعدك الذكي في الموبايل - متاح لجميع المستخدمين */}
                        <li><a href="/smart-assistant" onClick={() => setIsOpen(false)} className="ms-2"><FaRobot className="mx-2" style={{ color: '#667eea' }} />مساعدك الذكي</a></li>
                        
                        {/* رابط تحدث مع معلمك/طلابك في الموبايل - متغير حسب نوع المستخدم */}
                        {currentUser?.role !== "parent" && (
                            <li><a href="/chat" onClick={() => setIsOpen(false)}><FaComments className="mx-2" style={{color: '#667eea'}} />{currentUser?.role === "teacher" ? "تحدث مع طلابك" : "تحدث مع معلمك"}</a></li>
                        )}
                        
                        {/* رابط تعلم البرمجة في الموبايل - متاح لجميع المستخدمين */}
                        <li><a href="/learn-programming" onClick={() => setIsOpen(false)}><FaCode className="mx-2" style={{color: '#28a745'}} />تعلم البرمجة</a></li>
                        
                        {/* رابط الأسئلة التدريبية الذكية في الموبايل - متاح لجميع المستخدمين */}
                        <li><a href="/smart-questions" onClick={() => setIsOpen(false)}><FaQuestionCircle className="mx-2" style={{color: '#ffc107'}} />الأسئلة التدريبية</a></li>
                        
                        {/* روابط مختلفة حسب نوع المستخدم في الموبايل */}
                        {currentUser?.role === "parent" ? (
                            // روابط ولي الأمر في الموبايل
                            <>
                                <li><a href="/parent-child-lessons" onClick={() => setIsOpen(false)}><FaBookOpen className="mx-2" style={{color: '#17a2b8'}} />دروس الأبناء</a></li>
                                <li><a href="/teachers" onClick={() => setIsOpen(false)}><FaChalkboardTeacher className="mx-2" style={{color: '#6f42c1'}} />المعلمين</a></li>
                                                        <li><a href="/parent-child-reports" onClick={() => setIsOpen(false)}><FaChartBar className="mx-2" style={{color: '#fd7e14'}} />تقارير الأبناء</a></li>
                        <li><a href="/questions" onClick={() => setIsOpen(false)}><FaQuestion className="mx-2" style={{color: '#e83e8c'}} />سؤال وجواب</a></li>
                                <li><a href="/contact" onClick={() => setIsOpen(false)}><FaEnvelope className="mx-2" style={{color: '#dc3545'}} />تواصل معنا</a></li>
                                <li><a href="/about" onClick={() => setIsOpen(false)}><FaInfoCircle className="mx-2" style={{color: '#6c757d'}} />من نحن</a></li>
                                <li><a href="/discover" onClick={() => setIsOpen(false)}><FaCompass className="mx-2" style={{color: '#28a745'}} />استكشف</a></li>
                                <li><a href="/play" onClick={() => setIsOpen(false)}><FaGamepad className="mx-2" style={{color: '#ff6b35'}} />امرح مع علمني</a></li>
                                <li><a href="/labs" onClick={() => setIsOpen(false)}><FaFlask className="mx-2" style={{color: '#8e44ad'}} />معامل علمني</a></li>
                                <li><a href="/level-indicator" onClick={() => setIsOpen(false)}><FaChartLine className="mx-2" style={{color: '#00d4aa'}} />مؤشر المستوى</a></li>
                            </>
                        ) : currentUser?.role === "teacher" ? (
                            // روابط المعلم في الموبايل
                            <>
                                                        <li><a href="/lessons" onClick={() => setIsOpen(false)}><FaClock className="mx-2" style={{color: '#17a2b8'}} />الحصص</a></li>
                                    <li><a href="/students" onClick={() => setIsOpen(false)}><FaUsers className="mx-2" style={{color: '#6f42c1'}} />الطلاب</a></li>
                                <li><a href="/subjects" onClick={() => setIsOpen(false)}><FaBook className="mx-2" style={{color: '#17a2b8'}} />المواد</a></li>
                        <li><a href="/files" onClick={() => setIsOpen(false)}><FaFolder className="mx-2" style={{color: '#fd7e14'}} />ملفاتي</a></li>
                        <li><a href="/questions" onClick={() => setIsOpen(false)}><FaQuestion className="mx-2" style={{color: '#e83e8c'}} />سؤال وجواب</a></li>

                        <li><a href="/exams" onClick={() => setIsOpen(false)}><FaClipboardList className="mx-2" style={{ color: '#20c997' }} />الاختبارات</a></li>
                        <li><a href="/exam-history" onClick={() => setIsOpen(false)}><FaHistory className="mx-2" style={{ color: '#6c757d' }} />سجل الاختبارات</a></li>
                        {/* جدول المواعيد متاح للطلاب فقط */}
                        <li><a href="/competitions" onClick={() => setIsOpen(false)}><FaStar className="mx-2" style={{color: '#ffc107'}} />مسابقات وجوائز علمني</a></li>
                        <li><a href="/labs" onClick={() => setIsOpen(false)}><FaFlask className="mx-2" style={{color: '#8e44ad'}} />معامل علمني</a></li>
                        <li><a href="/play" onClick={() => setIsOpen(false)}><FaGamepad className="mx-2" style={{color: '#ff6b35'}} />امرح مع علمني</a></li>
                        <li><a href="/discover" onClick={() => setIsOpen(false)}><FaCompass className="mx-2" style={{color: '#28a745'}} />استكشف</a></li>
                                <li><a href="/about" onClick={() => setIsOpen(false)}><FaInfoCircle className="mx-2" style={{color: '#6c757d'}} />من نحن</a></li>
                                <li><a href="/contact" onClick={() => setIsOpen(false)}><FaEnvelope className="mx-2" style={{color: '#dc3545'}} />تواصل معنا</a></li>
                            </>
                        ) : (
                            // روابط الطالب في الموبايل (الالافتراضية)
                            <>
                                <li><a href="/lessons" onClick={() => setIsOpen(false)}><FaClock className="mx-2" style={{color: '#17a2b8'}} />الحصص</a></li>
                                <li><a href="/teachers" onClick={() => setIsOpen(false)}><FaChalkboardTeacher className="mx-2" style={{color: '#6f42c1'}} />المدرسين</a></li>
                                <li><a href="/subjects" onClick={() => setIsOpen(false)}><FaBook className="mx-2" style={{color: '#17a2b8'}} />المواد</a></li>
                                <li><a href="/files" onClick={() => setIsOpen(false)}><FaFolder className="mx-2" style={{color: '#fd7e14'}} />ملفاتي</a></li>
                                <li><a href="/questions" onClick={() => setIsOpen(false)}><FaQuestion className="mx-2" style={{color: '#e83e8c'}} />سؤال وجواب</a></li>
                                {/* مؤشر المستوى متاح للطالب */}
                                <li><a href="/level-indicator" onClick={() => setIsOpen(false)}><FaTrophy className="mx-2" style={{color: '#ffc107'}} />مؤشر المستوى</a></li>
                                <li><a href="/exams" onClick={() => setIsOpen(false)}><FaClipboardList className="mx-2" style={{color: '#20c997'}} />الاختبارات</a></li>
                                <li><a href="/exam-history" onClick={() => setIsOpen(false)}><FaHistory className="mx-2" style={{color: '#6c757d'}} />سجل الاختبارات</a></li>
                                
                                <li><a href="/schedule" onClick={() => setIsOpen(false)}><FaCalendarAlt className="mx-2" style={{ color: '#667eea' }} />جدول المواعيد</a></li>
                                <li><a href="/check-code" onClick={() => setIsOpen(false)}><FaKey className="mx-2" style={{color: '#6c757d'}} />تفعيل كود المادة</a></li>
                                <li><a href="/competitions" onClick={() => setIsOpen(false)}><FaStar className="mx-2" style={{color: '#ffc107'}} />مسابقات وجوائز علمني</a></li>
                                <li><a href="/labs" onClick={() => setIsOpen(false)}><FaFlask className="mx-2" style={{color: '#8e44ad'}} />معامل علمني</a></li>
                                <li><a href="/play" onClick={() => setIsOpen(false)}><FaGamepad className="mx-2" style={{color: '#ff6b35'}} />امرح مع علمني</a></li>
                                <li><a href="/discover" onClick={() => setIsOpen(false)}><FaCompass className="mx-2" style={{color: '#28a745'}} />استكشف</a></li>
                        <li><a href="/about" onClick={() => setIsOpen(false)}><FaInfoCircle className="mx-2" style={{color: '#6c757d'}} />من نحن</a></li>
                        <li><a href="/contact" onClick={() => setIsOpen(false)}><FaEnvelope className="mx-2" style={{color: '#dc3545'}} />تواصل معنا</a></li>
                            </>
                        )}
                    </ul>
                </div>
            </div>
        </>
    );
}

export default Navbar;
